import { ruleMessage } from '@cnamts/vue-dot/src/helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';

const defaultErrorMessages: ErrorMessages<number> = {
	default: () => 'Le nombre de caractères n’est pas respecté.'
};

/** Check that the field is exactly one of the lengthValues lengths */
export function exactLengths(
	lengthValues: number[],
	ignoreSpaces = false,
	errorMessages = defaultErrorMessages
) {
	return (value: string) => {
		if (!value) {
			return true;
		}

		if (ignoreSpaces) {
			value = value.replace(/\s/g, '');
		}

		return lengthValues.includes(value.length) || ruleMessage(errorMessages, 'default', []);
	};
}

export default exactLengths;
